import { all, putResolve, takeLatest } from 'redux-saga/effects';
import actions from '../../actions';
import * as stitchMethods from '../../utils/api/analysis/stitchVideo';
import { transcriptData } from '../../utils/api/analysis/transcriptCsvData';

function* transcriptCsvData(payload) {
  const promise = transcriptData(payload.payload);
  const { res } = yield promise;

  yield putResolve({ type: actions.TranscriptCsvData.DOWNLOAD_TRANSCRIPT_DATA_RECEIVED, data: res.Response });
}

export { transcriptCsvData };
